<div class="newer-session-overlay">
  <div class="newer-session-card">
    <div class="newer-session-card__illustration">
      <img src="assets/images/session-expired.png" alt="Newer session detected" />
    </div>

    <div class="newer-session-card__content">
      <h1 class="newer-session-card__title">Newer Session Detected</h1>
      <p class="newer-session-card__description">
        You're viewing an older instance of this page. Changes can't be made here because a more recent session is currently active.
      </p>
    </div>

    <div class="newer-session-card__actions">
      <button
        mwc-button
        mwcType="primary"
        mwcShape="round"
        mwcSize="medium"
        (click)="ok()"
        class="newer-session-card__btn"
        aria-label="Continue to My Profile Center"
        style="padding: 4px 24px;font-weight: 400;">
        OK
      </button>
    </div>
  </div>
</div>
